import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './NotFound.module.scss';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.notFound}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => navigate('/workspace')}>
            Back to Workspace
          </Button>
        }
      />
    </div>
  );
};
export default NotFound;
